import { Dispatch } from 'redux';
import { AlertAction, AlertActionTypes } from '../../types/alert';
import { v4 as uuidv4 } from 'uuid';

export const setAlert =
  (msg: string, alertType: string, timeout: number = 3000) =>
  (dispatch: Dispatch<AlertAction>) => {
    const id = uuidv4();
    dispatch({
      type: AlertActionTypes.SET_ALERT,
      payload: { msg, alertType, id },
    });

    setTimeout(
      () => dispatch({ type: AlertActionTypes.REMOVE_ALERT, payload: id }),
      timeout
    );
  };
